import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {featureKeyMap} from './feature-map.selectors';
import {FeatureMapReducer} from './feature-map.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(featureKeyMap, FeatureMapReducer),
  ],
})
export class FeatureMapModule {
}
